import { useEffect } from "react";
import { getReturningTasks } from "../../../redux/api/returning.api";
import { clearReturningTasks } from "../../../redux/reducer/returning.reducer";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import ReturningTasksActionButtons from "./components/ReturningTasksActionButtons";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getReturningTableData,
  returningTableHeader,
} from "./tableConfigs/returningTasksTableConfig";
import ReturningTasksActionButton from "./components/TableActionsButtonsComponents/ReturningTasksActionButton";
import ReturningTasksHeader from "./components/ReturningTasksHeader";

function ReturningTasks() {
  const dispatch = useAppDispatch();

  const {
    returning: {
      returningTasks: { data: avaibleReturns, isLoadingReturningTasks },
    },
  } = useAppSelector((state) => ({
    returning: state.returning,
  }));

  useEffect(() => {
    return () => {
      dispatch(clearReturningTasks());
    };
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch?.status &&
      action.tableSearch?.deliveryPoint != null
    ) {
      dispatch(
        getReturningTasks({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          status: action.tableSearch?.status,
          deliveryPoint: action.tableSearch?.deliveryPoint,
        }),
      );
    }
  };

  return (
    <div>
      <ReturningTasksActionButtons />
      <TableWidget
        CustomHeaderComponent={ReturningTasksHeader}
        tableHeaderData={returningTableHeader}
        tableItemsData={getReturningTableData(avaibleReturns.retururi)}
        tableLoading={isLoadingReturningTasks}
        handleTableActions={handleTableActions}
        totalItems={avaibleReturns.nrTotalRetururi}
        withGlobalSearch={false}
        ActionButtonsComponent={(props: any) => (
          <ReturningTasksActionButton {...props} />
        )}
      />
    </div>
  );
}

export default ReturningTasks;
